import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseToastIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.4851 1.51477L1.51454 18.4853",
		stroke: "#2B313A",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.4851 18.4854L1.51455 1.51479",
		stroke: "#2B313A",
		strokeWidth: 1.5
	})]
});
export default SvgCloseToastIcon;
